import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import {fromEvent, Subscription} from 'rxjs';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {DatePipe, isPlatformBrowser} from '@angular/common';
import {NgxPermissionsService} from 'ngx-permissions';
import {UtilsModule} from '../../utils/utils.module';
import {NzInputDirective} from 'ng-zorro-antd/input';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';

@Component({
  selector: 'task-new-table',
  templateUrl: './new-table.component.html',
  styleUrls: ['./new-table.component.css'],
  providers: [TaskService, DatePipe]
})
export class NewTableComponent implements OnInit, AfterViewInit, OnDestroy {
  dataSubscription: Subscription = null;
  boardId = null; // 存放面板ID
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  renderBoard: Array<any> = []; // 渲染面板数据
  boardGroupMapData = {}; // 重组分组MAP数据
  permissionDefinition: any; // 存放面板权限配置
  currentUser: any; // 存放当前用户信息
  boardWidth: number; // 面板宽度
  canColumnDrag = false; // 是否可拖动列宽
  showColumnShadow: boolean; // 是否显示列阴影
  subscribeScoll: any; // 监控滚动条
  visibleWidth: number; // 可视区域宽度
  visibleHeight: number; // 可视区域高度
  isPulseChecked = false;
  pulseCheckedId = []; // 选中行ID
  pulseCheckedData: any = {}; // 行选中数据
  addPulseNameValue = ''; // 添加行输入框绑定值
  editNameId: string | null; // 编辑ID
  clickCurrentColumnValue = null; // 是否点击当前列
  clickCurrentPulseValue = null; // 是否点击当前行
  progressSubmitState = false; // 进度分配提交按钮状态
  isConfirmLoading = false; // 批量修改弹窗提交按钮状态
  groupAuthority: any = {
    edit: {
      status: false,
      members: []
    },
    view: {
      status: false,
      members: []
    }
  }; // 分组权限
  initGroupColor = [
    'rgb(3, 127, 76)',
    'rgb(0, 200, 117)',
    'rgb(156, 211, 38)',
    'rgb(202, 182, 65)',
    'rgb(255, 203, 0)',
    'rgb(120, 75, 209)',
    'rgb(0, 134, 192)',
    'rgb(87, 155, 252)',
    'rgb(102, 204, 255)',
    'rgb(187, 51, 84)',
    'rgb(226, 68, 92)',
    'rgb(255, 21, 138)',
    'rgb(255, 90, 196)',
    'rgb(255, 100, 46)',
    'rgb(253, 171, 61)',
    'rgb(127, 83, 71)',
    'rgb(100,127,120)',
    'rgb(196, 196, 196)',
    'rgb(128, 128, 128)',
    'rgb(51, 51, 51)'
  ]; // group默认组颜色
  filterColumnExclude = ['progress', 'time-interval', 'relation-data', 'button', 'vote']; // 不支持筛选的列
  filterConditionCount = 0;
  filterData = {
    groups: [],
    selectedGroups: [],
    columns: []
  };
  conversationBaseData: any = {}; // 会话窗口基础数据
  confirmModal: NzModalRef; // 确认框
  tplModal: NzModalRef;
  isBatchEditVisible = false;
  movePulsePopVisible = false;
  @Input('nfData') set ChangeData(data: any) {
    if (JSON.stringify(data) !== '{}') {
      this.boardData = data;
      this.renderBoard = [];
      this.handleBoardData(this.boardData);
    }
  }
  // 动态加载组件暂不启用
  // @ViewChildren('dynamicColumnComponent', { read: ViewContainerRef }) dynamicColumnComponentRef: QueryList<ViewContainerRef>;
  // @ViewChildren('dynamicPulseComponent', { read: ViewContainerRef }) dynamicPulseComponentRef: QueryList<ViewContainerRef>;
  // dynamicColumnComponent: Array<ComponentRef<any>>;
  // dynamicPulseComponent: Array<ComponentRef<any>>;
  @Output() nfUpdateTable: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('addPulseInput') addPulseInput: ElementRef;
  @ViewChild(NzInputDirective, { read: ElementRef }) inputElement: ElementRef;
  @ViewChild('pulseCard') pulseCard: any;
  @ViewChild('tplFooter', { static: true }) tplFooter: any;
  @ViewChild('modalTplContent', { static: true }) modalTplContent: any;
  constructor(
    private componentFactory: ComponentFactoryResolver,
    private taskService: TaskService,
    private permissionsService: NgxPermissionsService,
    private message: NzMessageService,
    private modal: NzModalService,
    private utilsModule: UtilsModule,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }
  @HostListener('window:click', ['$event'])
  handleClick(e: MouseEvent): void {
    if (this.editNameId && this.inputElement && this.inputElement.nativeElement !== e.target &&
      !this.hasClass(e.target, 'cdk-overlay-backdrop nz-overlay-transparent-backdrop')) {
      this.editNameId = null;
    }
    if (this.clickCurrentColumnValue && this.hasClass(e.target, 'cdk-overlay-backdrop nz-overlay-transparent-backdrop')) {
      this.clickCurrentColumnValue = null;
    }
    if (this.clickCurrentPulseValue && this.hasClass(e.target, 'cdk-overlay-backdrop nz-overlay-transparent-backdrop')) {
      this.clickCurrentPulseValue = null;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.getVisibleSize();
  }
  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this.getVisibleSize();
  }
  ngOnDestroy(): void {
  }
  /**
   *
   * 面板操作
   *
   ***/
  // 处理面板数据
  handleBoardData(data) {
    if (data) {
      this.boardId = data.id;
      this.boardGroupData = data.boardData.groups ? data.boardData.groups : [];
      this.boardColumnData = data.boardData.columns ? data.boardData.columns : [];
      this.boardPulseData = data.boardData.pulses ? data.boardData.pulses : [];
      this.permissionDefinition = data.permissionDefinition;
      this.currentUser = data.boardData.currentUser;
      this.boardGroupData.forEach(i => {
        // 转对象
        if (i.id) {
          this.boardGroupMapData[i.id] = i;
        }
      });
      this.recombinationBoardPulseData(this.boardPulseData, this.boardGroupData);
      // load permissions
      this.permissionsService.loadPermissions(this.currentUser.permissions ? this.currentUser.permissions : []);
      // 计算面板宽度
      this.calcBoardWidth();
      setTimeout(() => {
        this.listenerScroll();
      }, 1000);
    }
  }
  // 处理重组面板数据
  recombinationBoardPulseData(pulseData, groupData) {
    const handleBoardData = this.sortClass(pulseData);
    // 处理没有行的分组
    if (handleBoardData.length !== groupData.length) {
      groupData.forEach((m, i) => {
        if (m.pulses && m.pulses.length === 0) {
          const headerObj = {
            isColumn: true,
            groupId: m.id,
            data: this.boardColumnData,
            group: m
          };
          const footerObj = {
            isFooter: true,
            groupId: m.id,
            group: m
          };
          const arr = [headerObj, footerObj];
          handleBoardData.splice(i, 0, arr);
        }
      });
    }
    this.renderBoard = [];
    handleBoardData.forEach(i => {
      i.forEach(j => {
        this.renderBoard.push(j);
      });
    });
  }
  // 计算面板宽度
  calcBoardWidth() {
    this.boardWidth = 100;
    this.boardColumnData.forEach((item, index) => {
      let val = 0;
      if (item.width) {
        val = item.width;
      } else {
        val = 166;
      }
      this.boardWidth = this.boardWidth + val;
    });
    if (document.getElementById('first-level-content')) {
      const cw = document.getElementById('first-level-content').clientWidth;
      this.canColumnDrag = cw < this.boardWidth;
    }
  }
  // 重组面板数据
  sortClass(sortData) {
    const groupBy = (array) => {
      const groups: {[key: string]: Array<any>} = {};
      array.forEach((item) => {
        const groupId = item.groupId;
        groups[groupId] = groups[groupId] || [];
        groups[groupId].push(item);
      });
      return Object.keys(groups).map((group) => {
        const newGroup = groups[group];
        const headerObj = {
          isColumn: true,
          data: this.boardColumnData,
          groupId: groups[group][0].groupId,
          group: this.boardGroupMapData[groups[group][0].groupId]
        };
        const footerObj = {
          isFooter: true,
          groupId: groups[group][0].groupId,
          group: this.boardGroupMapData[groups[group][0].groupId]
        };
        newGroup.unshift(headerObj);
        newGroup.push(footerObj);
        return newGroup;
      });
    };
    return groupBy(sortData);
  }
  // hasClass
  hasClass(elem, className) {
    const reg = new RegExp('(^|\\s+)' + className + '($|\\s+)');
    return reg.test(elem.className);
  }
  //  监听滚动条
  listenerScroll() {
    const scrollContainer = document.getElementById('virtual-scroll-viewport');
    if (scrollContainer) {
      this.subscribeScoll = fromEvent(scrollContainer, 'scroll')
        .subscribe((event) => {
          this.onWindowScroll(scrollContainer);
      });
    }
  }
  // 滚动条事件
  onWindowScroll(scrollContainer) {
    scrollContainer.scrollLeft > 0 ? this.showColumnShadow = true : this.showColumnShadow = false;
  }
  // 获取可视区域高度
  getVisibleHeight() {
    const visibleContainer = document.getElementById('first-level-content');
    console.log(visibleContainer);
  }
  // 获取可视区域宽度
  getVisibleSize() {
    const visibleContainer = document.getElementById('first-level-content');
    if (visibleContainer) {
      this.visibleWidth = visibleContainer.offsetWidth;
      this.visibleHeight = visibleContainer.offsetHeight;
    }
  }
  /**
  **
  * 列操作
  **
  * */
  // 添加分组
  addNewGroup(boardId) {
    const color = this.utilsModule.getRandomColor();
    const param = {};
    param['title'] = '新组';
    param['color'] = color;
    this.dataSubscription = this.taskService.doAddGroup(boardId, param).subscribe((res: any) => {
      if (res) {
        const groupObj = {
          'title': res.title,
          'color': res.color,
          'id': res.id,
          'boardId': res.boardId
        };
        this.boardGroupData = [
          groupObj,
          ...this.boardGroupData
        ];
        // 新增分组插入空行数据 2021/01/29
        const columnObj = {
          isColumn: true,
          group: res,
          groupId: res.id,
          data: this.boardColumnData
        };
        const footerObj = {
          isFooter: true,
          groupId: res.id,
          group: res
        };
        this.renderBoard = [columnObj, footerObj, ...this.renderBoard];
        // this.nfUpdateTable.emit(true);
      }
    });
  }
  // 删除组
  removeGroup(boardId, groupId) {
    const param = {
      'destroy': true
    };
    this.dataSubscription = this.taskService.doDeleteGroup(boardId, groupId, param).subscribe((res: any) => {
      this.boardGroupData = this.boardGroupData.filter(d => d.id !== groupId);
      this.boardPulseData = this.boardPulseData.filter(d => d.groupId !== groupId);
      this.renderBoard = this.renderBoard.filter(d => d.groupId !== groupId);
      this.pulseCheckedId = [];
    });
  }
  // 更换组颜色
  changeGroupColor(boardId, groupId, color) {
    const param = {
      color: color
    };
    this.boardGroupData.forEach((item, index) => {
      if (item.id === groupId) {
        item.color = color;
      }
    });
    this.dataSubscription = this.taskService.doEditGroupTitle(boardId, groupId, param).subscribe((res: any) => {});
  }
  // 归档组
  archiveGroup(boardId, groupId) {
    this.dataSubscription = this.taskService.doDeleteGroup(boardId, groupId, {}).subscribe((res: any) => {
      this.boardGroupData = this.boardGroupData.filter(d => d.id !== groupId);
      this.renderBoard = this.renderBoard.filter(d => d.groupId !== groupId);
    });
  }
  // 分组权限
  groupAuthorityChange(groupId, visible) {
    if (visible) {
      this.taskService.getGroupAuthority(this.boardId, groupId).subscribe(res => {
        if (res) {
          this.groupAuthority = res;
        }
      });
    }
  }
  getAuthorityMember(target, value) {
    target.members = value;
  }
  groupAuthorityConfirm(group) {
    this.taskService.setGroupAuthority(this.boardId, group.id, this.groupAuthority).subscribe(res => {
      if (res) {
        group['authorityPopVisible'] = false;
      } else {
        this.message.error('提交失败！');
      }
    });
  }
  // 添加组列
  addColumnFun(boardId, type) {
    const param = {
      type: type,
      title: type
    };
    this.dataSubscription = this.taskService.doAddColumn(boardId, param).subscribe((res: any) => {
      if (res) {
        const obj = JSON.parse(res.definition);
        this.nfUpdateTable.emit(true);
        this.setProgressValue();
        this.addFilterColumn(obj);
      }
    });
  }
  // 列组件回调事件
  getColumnChange(event) {
    if (event) {
      switch (event.event) {
        case 'removeColumn':
          if (event.status) {
            this.boardColumnData = this.boardColumnData.filter(d => d.id !== event.date.id);
            this.renderBoard.forEach((item, index) => {
              if (item.isColumn) {
                item.data = item.data.filter(d => d.id !== event.date.id);
              }
            });
            // 计算面板宽度
            this.calcBoardWidth();
            this.setProgressValue();
            this.removeFilterColumn(event.date.id);
          }
          break;
      }
    }
  }
  getColumnRefresh(event) {
    if (event) {
      this.nfUpdateTable.emit(true);
    }
  }
  // 选中组
  selectGroup(group) {
    const groupPulses = this.boardPulseData.filter(item => group.id === item.groupId);
    for (const pulse of groupPulses) {
      if (!this.pulseCheckedId.includes(pulse.id)) {
        this.pulseCheckedId.push(pulse.id);
        pulse.isDelete = true;
      }
    }
    this.pulseCheckedData = {
      isDelete: true,
      pulseIds: this.pulseCheckedId
    };
    group.menuPopVisible = false;
  }
  /**
   *
   * 行操作
   *
   ***/
  // 添加行输入框状态切换
  changeAddPulseEditable(groupId, columnId, event, inputTemp) {
    event.preventDefault();
    event.stopPropagation();
    this.editNameId = 'add' + groupId + columnId;
    // 自动获取输入框焦点
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this[inputTemp].nativeElement.focus();
      }
    }, 100);
  }
  // 添加组行
  addPulse(boardId, groupId) {
    const o = {};
    this.boardColumnData.forEach((item, index) => {
      switch (item.type) {
        case 'multiple-person':
          o[item.id] = {'personsAndTeams' : []};
          break;
        case 'status':
          o[item.id] = {
            'index': 0
          };
          break;
        case 'date':
          o[item.id] = {};
          break;
        case 'date-time':
          o[item.id] = {};
          break;
        case 'name':
          o[item.id] = this.addPulseNameValue;
          break;
        case 'dropdown':
          o[item.id] = {};
          break;
        case 'file':
          o[item.id] = {
            config: {
              watermark: true,
              watermarkContent: ''
            },
            files: []
          };
          break;
        case 'link':
          o[item.id] = {
            name: '',
            url: '',
            params: [],
            skipMode: '1'
          };
          break;
        default:
          o[item.id] = '';
          break;
      }
    });
    o['name'] = this.addPulseNameValue;
    const param = {};
    param['boardId'] = boardId;
    param['groupId'] = groupId;
    param['name'] = this.addPulseNameValue;
    param['columnValues'] = {
      'name': this.addPulseNameValue
    };
    this.dataSubscription = this.taskService.doAddPulse(param).subscribe((res: any) => {
      if (res) {
        const obj = {
          id: res.id,
          groupId: res.groupId,
          name: this.addPulseNameValue,
          columnValues: o,
          columnPermissions: res.columnPermissions,
          updatesCount: 0,
          updatesReadCount: 0,
        };
        this.boardPulseData = [
          ...this.boardPulseData,
          obj
        ];
        let count = 1;
        const cloneRenderBoard = JSON.parse(JSON.stringify(this.renderBoard));
        this.renderBoard = [];
        for (let i = 0; i < cloneRenderBoard.length; i++) {
          if (count === 1) {
            if (cloneRenderBoard[i].groupId === groupId && cloneRenderBoard[i].isFooter) {
              cloneRenderBoard.splice(i, 0, obj);
              count = count - 1;
            }
          }
        }
        this.renderBoard = cloneRenderBoard;
        // this.nfUpdateTable.emit(true);
      }
      this.addPulseNameValue = '';
    });
  }
  // 删除行
  removePulse(pulseId) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['isDelete'] = true;
    this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
      this.boardPulseData = this.boardPulseData.filter(d => d.id !== pulseId);
      this.renderBoard = this.renderBoard.filter(d => d.id !== pulseId);
    });
    // 重新计算选中
    if (this.pulseCheckedData && this.pulseCheckedData.pulseIds) {
      for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
        if (this.pulseCheckedData.pulseIds[i] === pulseId) {
          this.pulseCheckedData.pulseIds.splice(i, 1);
        }
      }
    }
  }
  // 归档行
  archivePulse(pulseId) {
    const param = {};
    param['pulseIds'] = [pulseId];
    this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
      this.boardPulseData = this.boardPulseData.filter(d => d.id !== pulseId);
      this.renderBoard = this.renderBoard.filter(d => d.id !== pulseId);
    });
    // 重新计算选中
    if (this.pulseCheckedData && this.pulseCheckedData.pulseIds) {
      for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
        if (this.pulseCheckedData.pulseIds[i] === pulseId) {
          this.pulseCheckedData.pulseIds.splice(i, 1);
        }
      }
    }
  }
  // 点击当前行显示状态切换
  clickCurrentPulse(pulseId) {
    this.clickCurrentPulseValue = pulseId;
  }
  // 行选中事件
  updatePulseChecked(event) {
  }
  /**
   *
   * 拖动操作
   *
   ***/
  // 列拖动
  columnDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.boardColumnData, event.previousIndex, event.currentIndex);
  }
  // 分组拖动
  groupDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.boardGroupData, event.previousIndex, event.currentIndex);
  }
  // 行拖动
  pulseDrop(event: CdkDragDrop<string[]>) {
    let groupId = this.boardPulseData[event.previousIndex]['groupId'];
    moveItemInArray(this.boardPulseData, event.previousIndex, event.currentIndex);
    const groupIndex = {};
    let i = 1;
    for (let item of this.boardGroupData) {
      if (!groupIndex[item.id]) {
        groupIndex[item.id] = i;
        i++
      }
    }
    this.boardPulseData.sort((v1, v2) => {
      return groupIndex[v1.groupId] - groupIndex[v2.groupId];
    });
    this.recombinationBoardPulseData(this.boardPulseData, this.boardGroupData);
    const pulses = this.boardPulseData.filter(item => item.groupId == groupId);
    this.taskService.pulseSort(pulses).subscribe(res => {
      if (!res) {
        this.message.error("拖动失败，请稍后重试！");
      }
    });
  }
  /**
  *
  * 筛选操作
  *
  *
  * */
  addFilterColumn(source) {
    if (this.filterColumnExclude.includes(source.type)) {
      return;
    }
    this.filterData.columns.push({
      columnId: source.id,
      type: source.type,
      name: source.title,
      maxHeight: '240px',
      valueMaxHeight: '',
      columnValues: [{title: '', value: '', count: this.boardPulseData.length}],
      selectedValue: []
    });
  }
  removeFilterColumn(columnId) {
    const index = this.filterData.columns.findIndex(item => item.columnId === columnId);
    this.filterData.columns.splice(index, 1);
    this.filter();
  }
  filter() {
    const groupSet = new Set();
    const pulses = [];
    const groupIds = [];
    for (const group of this.filterData.selectedGroups) {
      groupIds.push(group.groupId);
    }
    if (this.boardData.boardData.pulses && this.boardData.boardData.pulses.length > 0) {
      for (const pulse of this.boardData.boardData.pulses) {
        if (groupIds.length > 0 && !groupIds.includes(pulse.groupId)) {
          continue;
        }
        let flag = true;
        if (this.filterData.columns.length > 0) {
          for (const filterColumn of this.filterData.columns) {
            const values = [];
            for (const item of filterColumn.selectedValue) {
              if (filterColumn.type === 'link') {
                values.push(item);
              } else {
                values.push(item.value);
              }
            }
            if (values.length > 0) {
              let cellValue = pulse.columnValues[filterColumn.columnId];
              switch (filterColumn.type) {
                case 'date-time':
                case 'date':
                  const v = cellValue && cellValue['date'] ? cellValue['date'] : '';
                  flag = values.includes(v);
                  break;
                case 'file':
                  if (cellValue && cellValue['files'] && cellValue['files'].length > 0) {
                    let fileFlag = false;
                    for (const file of cellValue['files']) {
                      fileFlag = fileFlag || values.includes(file.name);
                    }
                    flag = fileFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'link':
                  flag = cellValue && (values.findIndex(item => item.value === cellValue['url'] && item.title === cellValue['name']) > -1);
                  break;
                case 'name':
                case 'text':
                  cellValue = cellValue || '';
                  flag = values.includes(cellValue);
                  break;
                case 'multiple-person':
                  if (cellValue && cellValue['personsAndTeams'] && cellValue['personsAndTeams'].length > 0) {
                    let personFlag = false;
                    for (const person of cellValue['personsAndTeams']) {
                      personFlag = personFlag || values.includes(person.id);
                    }
                    flag = personFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'status':
                  flag = values.includes(cellValue['index']);
                  break;
                case 'dropdown':
                  if (cellValue && cellValue['ids'] && cellValue['ids'].length > 0) {
                    let dropFlag = false;
                    for (const id of cellValue['ids']) {
                      dropFlag = dropFlag || values.includes(id);
                    }
                    flag = dropFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'select':
                  flag = values.includes(cellValue['option']);
                  break;
                case 'check':
                  for (const value of values) {
                    if (value === 'true') {
                      flag = value === cellValue;
                    } else {
                      flag = (cellValue === '\"true\"' || cellValue === 'false');
                    }
                    if (flag) {
                      break;
                    }
                  }
                  break;
              }
              if (!flag) {
                break;
              }
            }
          }
        }
        if (flag) {
          groupSet.add(pulse.groupId);
          pulses.push(pulse);
        }
      }
    }
    this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups.filter((item) => {
      return groupIds.length > 0 ? groupIds.includes(item.id) && groupSet.has(item.id) : true;
    }) : [];
    this.boardPulseData = pulses;
  }

  isExist(arr: Array<any>, obj, attr, attr2?): boolean {
    for (const item of arr) {
      if (item[attr] === obj[attr]) {
        if (attr2) {
          if (item[attr2] === obj[attr2]) {
            item.count++;
            return true;
          }
        } else {
          item.count++;
          return true;
        }
      }
    }
    return false;
  }
  /**
   *
   * 其他处理
   *
   ***/
  trackByItems(index: number, item: any): number {
    return item.id;
  }
  // 进度条组件-进度赋值
  setProgressValue() {
    let count = 0;
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'status' && item.checked) {
        count = count + 1;
      }
    });
    let i = count;
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'status' && item.checked && i >= 0) {
        item.value = this.progressAverage(count)[count - i];
        i = i - 1;
      }
    });
    this.progressCalcValue();
  }
  // 平均分配
  progressAverage(count) {
    const value = [];
    let remainder = 100 % count;
    if (remainder === 0) {
      for (let i = 0; i < count; i++) {
        value.push(100 / count);
      }
    } else {
      for (let i = 0; i < count; i++) {
        if (remainder !== 0) {
          value.push(parseInt(((100 / count) + 1).toString(), 0));
          remainder = remainder - 1;
        } else {
          const num = 100 / count;
          value.push( parseInt(num.toString(), 0) );
        }
      }
    }
    return value;
  }
  // 进度条组件-复选框选中事件
  progressCheckboxChange(event) {
    const data = event;
    for (let i = 0; i < this.boardColumnData.length; i++) {
      if (this.boardColumnData[i].type === 'status') {
        this.boardColumnData[i].checked = false;
      }
    }
    if (data.length > 0) {
      for (let i = 0; i < this.boardColumnData.length; i++) {
        if (this.boardColumnData[i].type === 'status') {
          for (let j = 0; j < data.length; j++) {
            if (data[j] === this.boardColumnData[i].id) {
              this.boardColumnData[i].checked = true;
              this.progressSubmitState = false;
            }
          }
        }
      }
    } else {
      for (let j = 0; j < this.boardColumnData.length; j++) {
        if (this.boardColumnData[j].type === 'status') {
          this.boardColumnData[j].checked = false;
          this.progressSubmitState = true;
        }
      }
    }
    this.setProgressValue();
  }
  // 进度条组件-提交设置
  submitProgressConfig() {
    let value = 0;
    for (let i = 0; i < this.boardColumnData.length; i++) {
      if (this.boardColumnData[i].type === 'status' && this.boardColumnData[i].checked) {
        value = value + Number(this.boardColumnData[i].value);
      }
    }
    if (value > 100) {
      this.message.create('error', '总数不能超过100%！');
      return false;
    } else {
      // 提交
      this.progressCalcValue();
    }
  }
  // 进度条组件-根据进度分配权重计算进度值
  progressCalcValue() {
    const value = [];
    const progressId = [];
    for (const key in this.boardColumnData) {
      if (this.boardColumnData.hasOwnProperty(key)) {
        if (this.boardColumnData[key].type === 'status' && this.boardColumnData[key].value && this.boardColumnData[key].checked) {
          const o = {
            key: this.boardColumnData[key].id,
            value: Number(this.boardColumnData[key].value)
          };
          value.push(o);
        }
        if (this.boardColumnData[key].type === 'progress') {
          progressId.push(this.boardColumnData[key].id);
        }
      }
    }
    for (let i = 0; i < this.boardPulseData.length; i++) {
      let num = 0;
      for (const key in this.boardPulseData[i].columnValues) {
        if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
          for (let j = 0; j < progressId.length; j++) {
            if (progressId[j] === key) {
              this.boardPulseData[i].columnValues[key] = 0;
            }
          }
        }
      }
      for (let j = 0; j < value.length; j++) {
        if (this.boardPulseData[i].columnValues[value[j].key] && this.boardPulseData[i].columnValues[value[j].key].index === 2) {
          num = num + value[j].value;
          for (const key in this.boardPulseData[i].columnValues) {
            if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
              for (let k = 0; k < progressId.length; k++) {
                if (progressId[k] === key) {
                  this.boardPulseData[i].columnValues[key] = num;
                }
              }
            }
          }
        }
      }
    }
  }
  // 打开会话窗口
  openConversationDialog(boardId, column, pulse) {
    pulse.isConversationDialogVisible = true;
    this.conversationBaseData = {
      'boardId': boardId,
      'column': column,
      'pulse': pulse,
      'currentUser': this.boardData.boardData.currentUser,
      'permissionDefinition': this.boardData.permissionDefinition
    };
  }
  closeConversationDialog(pulse) {
    pulse.isConversationDialogVisible = false;
  }
  // 行选中事件
  pulseCheckedChange(pulse) {
    pulse.isPulseChecked = !pulse.isPulseChecked;
    if (pulse.isPulseChecked) {
      this.pulseCheckedId.push(pulse.id);
    } else {
      this.pulseCheckedId = this.pulseCheckedId.filter(d => d !== pulse.id);
    }
    const o = {
      isDelete: true,
      pulseIds: this.pulseCheckedId
    };
    this.pulseCheckedData = o;
    if (this.pulseCheckedId && this.pulseCheckedId.length > 0) {
      this.renderBoard.forEach(item => {
        if (!item.isColumn || !item.isFooter) {
          item.isPulseOpenSelection = true;
        }
      });
    } else {
      this.renderBoard.forEach(item => {
        if (!item.isColumn || !item.isFooter) {
          item.isPulseOpenSelection = false;
        }
      });
    }
  }
  // 关闭批量操作浮动菜单
  closeBatchMenu() {
    this.pulseCheckedData.pulseIds = [];
    this.pulseCheckedId = [];
    this.renderBoard.forEach(item => {
      if (!item.isColumn || !item.isFooter) {
        item.isPulseOpenSelection = false;
        item.isPulseChecked = false;
      }
    });
  }
  // 批量移动
  moveToGroup(group) {
    this.taskService.moveToGroup(this.boardId, {groupId: group.id, pulseIds: this.pulseCheckedId}).subscribe(res => {
      if (res) {
        for (const pulse of this.boardPulseData) {
          if (this.pulseCheckedId.includes(pulse.id)) {
            pulse.groupId = group.id;
          }
        }
        this.closeBatchMenu();
        this.nfUpdateTable.emit(true);
      } else {
        this.message.error('移至分组失败!');
      }
    });
  }
  // 弹窗批量编辑
  getPulseCardData(data) {
    if (data.columnValues && data.columnValues.length > 0) {
      this.isConfirmLoading = true;
      this.dataSubscription = this.taskService.batchChangeColumn(this.boardId, data).subscribe((res: any) => {
        this.isConfirmLoading = false;
        this.message.create('success', '更新成功！');
        this.nfUpdateTable.emit(true);
        this.tplModal.destroy();
        this.pulseCheckedId = [];
      }, (err) => {
        this.isConfirmLoading = false;
        this.message.create('error', '更新失败！');
      });
    } else {
      this.message.create('info', '无修改项！');
    }
  }
  // 批量编辑
  batchEditPulse() {
    this.isBatchEditVisible = true;
    this.tplModal = this.modal.create({
      nzContent: this.modalTplContent,
      nzMaskClosable: false,
      nzFooter: this.tplFooter,
      nzTitle: null,
      nzWidth: '30%',
      nzWrapClassName: 'vertical-center-modal',
    });
  }
  // 批量编辑弹窗按钮事件
  handleAddCancel() {
    this.tplModal.destroy();
    this.isBatchEditVisible = false;
  }
  handleAddOk() {
    this.pulseCard.onSubmit();
  }
  // 批量归档
  batchArchivePulse() {
    this.confirmModal = this.modal.confirm({
      nzTitle: '是否确认归档?',
      nzWrapClassName: 'vertical-center-modal',
      nzOnOk: () => {
        const param = {};
        param['pulseIds'] = this.pulseCheckedData.pulseIds;
        this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
          for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
            this.boardPulseData = this.boardPulseData.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
            this.renderBoard = this.renderBoard.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
          }
          this.closeBatchMenu();
        });
      }
    });
  }
  // 批量删除行
  batchDeletePulse() {
    this.confirmModal = this.modal.confirm({
      nzTitle: '是否确认删除?',
      nzWrapClassName: 'vertical-center-modal',
      nzOnOk: () => {
        this.dataSubscription = this.taskService.doDeletePulse(this.pulseCheckedData).subscribe((res: any) => {
          for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
            this.boardPulseData = this.boardPulseData.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
            this.renderBoard = this.renderBoard.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
          }
          this.closeBatchMenu();
        });
      }
    });
  }
  // 动态创建列组件
  // private createColumnComponent() {
  //   this.dynamicColumnComponent = [];
  //   this.dynamicColumnComponentRef.forEach((componentRef, index) => {
  //     let columnData: any;
  //     let groupData: any;
  //     if (componentRef.element.nativeElement.columnData) {
  //       columnData = JSON.parse(componentRef.element.nativeElement.columnData);
  //     }
  //     if (componentRef.element.nativeElement.groupData) {
  //       groupData = JSON.parse(componentRef.element.nativeElement.groupData);
  //     }
  //     componentRef.clear();
  //     if (columnData.type && TableAssembleComponent[columnData.type + 'Column']) {
  //       const targetComponent: Type<any> = TableAssembleComponent[columnData.type + 'Column'];
  //       const component = this.componentFactory.resolveComponentFactory(targetComponent);
  //       const com = componentRef.createComponent(component);
  //       this.dynamicColumnComponent.push(com);
  //       com.instance.columnData = columnData;
  //       com.instance.groupData = groupData;
  //     }
  //   });
  // }
  // 动态创建行组件
  // private createPulseComponent() {
  //   this.dynamicPulseComponent = [];
  //   this.dynamicPulseComponentRef.forEach((componentRef, index) => {
  //     let columnData: any;
  //     let groupData: any;
  //     let pulseData: any;
  //     if (componentRef.element.nativeElement.columnData) {
  //       columnData = JSON.parse(componentRef.element.nativeElement.columnData);
  //     }
  //     if (componentRef.element.nativeElement.groupData) {
  //       groupData = JSON.parse(componentRef.element.nativeElement.groupData);
  //     }
  //     if (componentRef.element.nativeElement.pulseData) {
  //       pulseData = JSON.parse(componentRef.element.nativeElement.pulseData);
  //     }
  //     componentRef.clear();
  //     if (columnData.type && TableAssembleComponent[columnData.type]) {
  //       const targetComponent: Type<any> = TableAssembleComponent[columnData.type];
  //       const component = this.componentFactory.resolveComponentFactory(targetComponent);
  //       const com = componentRef.createComponent(component);
  //       this.dynamicPulseComponent.push(com);
  //       com.instance.columnData = columnData;
  //       com.instance.groupData = groupData;
  //       com.instance.pulseData = pulseData;
  //     }
  //   });
  // }
}
